var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsroomHeroBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1552,
    height: 345,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M643.721 344C643.721 241.828 561.011 159 458.985 159C356.958 159 273.977 241.828 273.977 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M651.066 344C651.066 250.002 568.356 173.713 466.33 173.713C364.303 173.713 281.594 250.002 281.594 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M658.412 344C658.412 258.175 575.703 188.426 473.676 188.426C371.65 188.426 288.668 258.175 288.668 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M665.759 344C665.759 266.349 583.05 203.411 481.023 203.411C378.997 203.411 296.287 266.349 296.287 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M673.377 344C673.377 274.523 590.668 218.124 488.641 218.124C386.614 218.124 303.633 274.523 303.633 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M680.723 344C680.723 282.697 598.013 232.837 495.987 232.837C393.96 232.837 310.979 282.697 310.979 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M688.069 344C688.069 290.87 605.359 247.822 503.332 247.822C401.306 247.822 318.324 290.87 318.324 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M695.414 344C695.414 299.044 612.705 262.535 510.678 262.535C408.652 262.535 325.67 299.044 325.67 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M702.759 344C702.759 307.218 620.05 277.248 518.023 277.248C415.997 277.248 333.287 307.218 333.287 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M710.107 344C710.107 315.392 627.398 292.233 525.371 292.233C423.344 292.233 340.635 315.392 340.635 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M717.725 344C717.725 323.566 635.015 306.946 532.989 306.946C430.962 306.946 347.98 323.566 347.98 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M725.071 344C725.071 331.739 642.361 321.658 540.334 321.658C438.308 321.658 355.326 331.739 355.326 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M458.711 344C458.711 241.828 541.42 159 643.447 159C745.474 159 828.455 241.828 828.455 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M451.365 344C451.365 250.002 534.075 173.713 636.101 173.713C738.128 173.713 820.838 250.002 820.838 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M444.02 344C444.02 258.175 526.729 188.426 628.756 188.426C730.782 188.426 813.764 258.175 813.764 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M436.674 344C436.674 266.349 519.383 203.411 621.41 203.411C723.437 203.411 806.418 266.349 806.418 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M429.328 344C429.328 274.523 512.038 218.124 614.064 218.124C716.091 218.124 799.072 274.523 799.072 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M421.982 344C421.982 282.697 504.692 232.837 606.719 232.837C708.745 232.837 791.455 282.697 791.455 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M414.365 344C414.365 290.87 497.075 247.822 599.101 247.822C701.128 247.822 784.11 290.87 784.11 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M407.018 344C407.018 299.044 489.727 262.535 591.754 262.535C693.78 262.535 776.762 299.044 776.762 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M399.672 344C399.672 307.218 482.381 277.248 584.408 277.248C686.435 277.248 769.144 307.218 769.144 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M392.326 344C392.326 315.392 475.036 292.233 577.062 292.233C679.089 292.233 761.798 315.392 761.798 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M384.98 344C384.98 323.566 467.69 306.946 569.717 306.946C671.743 306.946 754.725 323.566 754.725 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M377.635 344C377.635 331.739 460.344 321.658 562.371 321.658C664.397 321.658 747.107 331.739 747.107 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M370.018 344C370.018 339.913 452.727 336.644 554.754 336.644C656.78 336.644 739.762 339.913 739.762 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M732.416 344C732.416 339.913 649.706 336.644 547.679 336.644C477.213 336.644 415.997 338.278 384.709 340.458",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2402 344C89.2402 241.828 171.95 159 273.976 159C376.003 159 458.713 241.828 458.713 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6211 344C81.6211 250.002 164.603 173.713 266.629 173.713C368.656 173.713 451.365 250.002 451.365 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2754 344C74.2754 258.175 156.985 188.426 259.011 188.426C361.038 188.426 444.02 258.175 444.02 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9297 344C66.9297 266.349 149.639 203.411 251.666 203.411C353.692 203.411 436.674 266.349 436.674 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.584 344C59.584 274.523 142.294 218.124 244.32 218.124C346.347 218.124 429.328 274.523 429.328 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2383 344C52.2383 282.697 134.948 232.837 236.974 232.837C339.001 232.837 421.983 282.697 421.983 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8926 344C44.8926 290.87 127.602 247.822 229.629 247.822C331.655 247.822 414.365 290.87 414.365 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2734 344C37.2734 299.044 119.983 262.535 222.01 262.535C324.036 262.535 407.018 299.044 407.018 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9277 344C29.9277 307.218 112.637 277.248 214.936 277.248C317.235 277.248 399.672 307.218 399.672 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.582 344C22.582 315.392 105.292 292.233 207.318 292.233C309.345 292.233 392.054 315.392 392.054 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2363 344C15.2363 323.566 97.9459 306.946 199.972 306.946C301.999 306.946 384.981 323.566 384.981 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89062 344C7.89062 331.739 90.6002 321.658 192.627 321.658C294.653 321.658 377.635 331.739 377.635 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0.544922 344C0.544921 339.913 83.2545 336.644 185.281 336.644C287.308 336.644 370.017 339.913 370.017 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M362.671 344C362.671 339.913 279.962 336.644 177.935 336.644C107.469 336.644 46.253 338.278 14.9648 340.458",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M908.279 344C908.279 241.828 990.989 159 1093.02 159C1195.04 159 1278.02 241.828 1278.02 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M900.934 344C900.934 250.002 983.644 173.713 1085.67 173.713C1187.7 173.713 1270.41 250.002 1270.41 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M893.588 344C893.588 258.175 976.297 188.426 1078.32 188.426C1180.35 188.426 1263.33 258.175 1263.33 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M886.241 344C886.241 266.349 968.95 203.411 1070.98 203.411C1173 203.411 1255.71 266.349 1255.71 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M878.623 344C878.623 274.523 961.332 218.124 1063.36 218.124C1165.39 218.124 1248.37 274.523 1248.37 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M871.277 344C871.277 282.697 953.987 232.837 1056.01 232.837C1158.04 232.837 1241.02 282.697 1241.02 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M863.931 344C863.931 290.87 946.641 247.822 1048.67 247.822C1150.69 247.822 1233.68 290.87 1233.68 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M856.586 344C856.586 299.044 939.295 262.535 1041.32 262.535C1143.35 262.535 1226.33 299.044 1226.33 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M849.241 344C849.241 307.218 931.95 277.248 1033.98 277.248C1136 277.248 1218.71 307.218 1218.71 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M841.893 344C841.893 315.392 924.602 292.233 1026.63 292.233C1128.66 292.233 1211.37 315.392 1211.37 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M834.275 344C834.275 323.566 916.985 306.946 1019.01 306.946C1121.04 306.946 1204.02 323.566 1204.02 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M826.929 344C826.929 331.739 909.639 321.658 1011.67 321.658C1113.69 321.658 1196.67 331.739 1196.67 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.29 344C1093.29 241.828 1010.58 159 908.553 159C806.526 159 723.545 241.828 723.545 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.63 344C1100.63 250.002 1017.93 173.713 915.899 173.713C813.872 173.713 731.162 250.002 731.162 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.98 344C1107.98 258.175 1025.27 188.426 923.244 188.426C821.218 188.426 738.236 258.175 738.236 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.33 344C1115.33 266.349 1032.62 203.411 930.59 203.411C828.563 203.411 745.582 266.349 745.582 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.67 344C1122.67 274.523 1039.96 218.124 937.936 218.124C835.909 218.124 752.928 274.523 752.928 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.02 344C1130.02 282.697 1047.31 232.837 945.281 232.837C843.255 232.837 760.545 282.697 760.545 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.63 344C1137.63 290.87 1054.93 247.822 952.899 247.822C850.872 247.822 767.89 290.87 767.89 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.98 344C1144.98 299.044 1062.27 262.535 960.246 262.535C858.22 262.535 775.238 299.044 775.238 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.33 344C1152.33 307.218 1069.62 277.248 967.592 277.248C865.565 277.248 782.856 307.218 782.856 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.67 344C1159.67 315.392 1076.96 292.233 974.938 292.233C872.911 292.233 790.202 315.392 790.202 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.02 344C1167.02 323.566 1084.31 306.946 982.283 306.946C880.257 306.946 797.275 323.566 797.275 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.37 344C1174.37 331.739 1091.66 321.658 989.629 321.658C887.603 321.658 804.893 331.739 804.893 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.98 344C1181.98 339.913 1099.27 336.644 997.246 336.644C895.22 336.644 812.238 339.913 812.238 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M819.584 344C819.584 339.913 902.294 336.644 1004.32 336.644C1074.79 336.644 1136 338.278 1167.29 340.458",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.76 344C1462.76 241.828 1380.05 159 1278.02 159C1176 159 1093.29 241.828 1093.29 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.38 344C1470.38 250.002 1387.4 173.713 1285.37 173.713C1183.34 173.713 1100.63 250.002 1100.63 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.72 344C1477.72 258.175 1395.02 188.426 1292.99 188.426C1190.96 188.426 1107.98 258.175 1107.98 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.07 344C1485.07 266.349 1402.36 203.411 1300.33 203.411C1198.31 203.411 1115.33 266.349 1115.33 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1492.42 344C1492.42 274.523 1409.71 218.124 1307.68 218.124C1205.65 218.124 1122.67 274.523 1122.67 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.76 344C1499.76 282.697 1417.05 232.837 1315.03 232.837C1213 232.837 1130.02 282.697 1130.02 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.11 344C1507.11 290.87 1424.4 247.822 1322.37 247.822C1220.34 247.822 1137.64 290.87 1137.64 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.73 344C1514.73 299.044 1432.02 262.535 1329.99 262.535C1227.96 262.535 1144.98 299.044 1144.98 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.07 344C1522.07 307.218 1439.36 277.248 1337.06 277.248C1234.77 277.248 1152.33 307.218 1152.33 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1529.42 344C1529.42 315.392 1446.71 292.233 1344.68 292.233C1242.66 292.233 1159.95 315.392 1159.95 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1536.76 344C1536.76 323.566 1454.05 306.946 1352.03 306.946C1250 306.946 1167.02 323.566 1167.02 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1544.11 344C1544.11 331.739 1461.4 321.658 1359.37 321.658C1257.35 321.658 1174.37 331.739 1174.37 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1551.46 344C1551.46 339.913 1468.75 336.644 1366.72 336.644C1264.69 336.644 1181.98 339.913 1181.98 344",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.33 344C1189.33 339.913 1272.04 336.644 1374.06 336.644C1444.53 336.644 1505.75 338.278 1537.04 340.458",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsroomHeroBg);
export default __webpack_public_path__ + "static/media/newsroom-hero-bg.cdfb54df469f88ff5aa39791a81ddcc5.svg";
export { ForwardRef as ReactComponent };